import { CellProps } from 'react-table';

import { Tag } from 'types/tag';

import { TaggableEntityObject } from 'hooks/useEntities';
import {
  useAddEntityTags,
  UseAddEntityTagsOptions,
} from 'tags/hooks/useAddEntityTag';
import { useDeleteEntityTags } from 'tags/hooks/useDeleteEntityTags';

import { TagsList } from 'tags/components/TagsList/TagsList';

export type TableLabelsCellProps<T extends TaggableEntityObject> =
  CellProps<T> &
    UseAddEntityTagsOptions & {
      readOnly?: boolean;
    };

export function TableLabelsCell<T extends TaggableEntityObject>({
  row: { id, original },
  entity,
  singleQueryKey,
  listQueryKey,
  readOnly,
}: TableLabelsCellProps<T>) {
  const { mutate: addTags } = useAddEntityTags<T>({
    entity,
    singleQueryKey,
    listQueryKey,
  });
  const { mutate: removeTags } = useDeleteEntityTags<T>({
    entity,
    singleQueryKey,
    listQueryKey,
  });

  function handleAdd(tag: Tag) {
    addTags({ id, tagIds: [tag.id] });
  }

  function handleRemove(tagId: Tag['id']) {
    removeTags({ id, tagIds: [tagId] });
  }

  return (
    <TagsList
      defaultValue={original.tags}
      onAdd={handleAdd}
      onRemove={handleRemove}
      readOnly={readOnly}
      hideButton
    />
  );
}
